import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-039add37")
const _hoisted_1 = {
  key: 0,
  shadow: "none",
  class: "title"
}
const _hoisted_2 = { class: "flex cursor-pointer items-center text-[14px] font-semibold text-[#CAC7CC]" }
const _hoisted_3 = { class: "mr-2" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "flex justify-between text-xs" }
const _hoisted_8 = { class: "token-amount" }
const _hoisted_9 = { class: "token-symbol" }
const _hoisted_10 = { class: "flex flex-col items-end" }
const _hoisted_11 = { class: "token-amount" }
const _hoisted_12 = { class: "token-symbol" }
const _hoisted_13 = { class: "relative mt-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "pair-line dotted-border absolute mx-9 h-1/2 border-b" }, null, -1)
const _hoisted_15 = { class: "relative z-10 flex justify-between" }
const _hoisted_16 = { class: "relative my-1.5 mx-4" }
const _hoisted_17 = { class: "relative z-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "ml-4 flex w-4 items-center" }, null, -1)
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "percentage mr-4 w-10 text-right text-xs" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAsset = _resolveComponent("BalAsset")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_ArrowUp = _resolveComponent("ArrowUp")!

  return (_ctx.routes.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('tradeRoute')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.routes.length === 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "text-secondary mt-5 text-sm",
                textContent: _toDisplayString(_ctx.$t('noData'))
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.input.amount), 1),
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.input.symbol), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.output.amount), 1),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.output.symbol), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_BalAsset, {
                        address: _ctx.input.address,
                        size: 36
                      }, null, 8, ["address"]),
                      _createVNode(_component_BalAsset, {
                        address: _ctx.output.address,
                        size: 36
                      }, null, 8, ["address"])
                    ])
                  ])
                ]),
                _createElementVNode("div", {
                  class: "flex justify-between",
                  style: _normalizeStyle({ margin: `8px ${12 + _ctx.routes.length}px` })
                }, [
                  _createVNode(_component_ArrowDown),
                  _createVNode(_component_ArrowUp)
                ], 4),
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      style: _normalizeStyle({
              height: `${18 + 70 * index}px`,
              width: `calc(100% - ${4 * (_ctx.routes.length - index - 1)}px + 1px)`,
              margin: `0 ${2 * (_ctx.routes.length - index - 1) - 1}px`,
            }),
                      class: "border-design absolute"
                    }, null, 4))
                  }), 128)),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: route.hops[0]?.pool?.address,
                        class: "mt-9 flex justify-between first:mt-0"
                      }, [
                        _hoisted_18,
                        _createElementVNode("div", _hoisted_19, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.hops, (hop) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: hop?.pool?.address,
                              class: "route ml-4 flex first:ml-0"
                            }, [
                              _createElementVNode("a", {
                                class: "flex",
                                href: _ctx.getPoolLink(hop.pool.id),
                                target: "_blank"
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hop.pool.tokens, (token) => {
                                  return (_openBlock(), _createBlock(_component_BalAsset, {
                                    key: token.address,
                                    class: "ml-1.5 h-24 w-24 first:ml-0",
                                    address: token.address,
                                    size: 24
                                  }, null, 8, ["address"]))
                                }), 128))
                              ], 8, _hoisted_20)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.formatShare(route.share)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
        ])
      ]))
    : _createCommentVNode("", true)
}